import React from 'react';

const PoModal = ({ po, onClose }) => {
  if (!po) return null;

  return (
    <div className="modal-overlay" style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div className="modal-content" style={{
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        width: '80%',
        maxHeight: '80%',
        overflowY: 'auto',
        position: 'relative'
      }}>
        <button onClick={onClose} style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          fontSize: '16px',
          cursor: 'pointer'
        }}>Close</button>
        <h2>Purchase Order Details - {po.po_number}</h2>
        <div>
          <p><strong>PO Number:</strong> {po.po_number}</p>
          <p><strong>Date:</strong> {new Date(po.po_date).toLocaleDateString()}</p>
          <p><strong>Name:</strong> {po.vendor_name}</p>
          <p><strong>Taxable Amount:</strong> {po.tax_amount}</p>
          <p><strong>Total Amount:</strong> {po.total_amount}</p>
          <p><strong>GST No:</strong> {po.vendor_gst}</p>
          <p><strong>Contact Info:</strong> {po.vendor_email} / {po.vendor_phone}</p>
          <p><strong>Status:</strong> {po.status}</p>

          {/* Add more invoice details as needed */}
        </div>
      </div>
    </div>
  );
};

export default PoModal;
